module.exports = __webpack_public_path__ + "img/医疗咨询 各种各样的保障.7fc7991f.png";